import { LinkButton } from '@cluey/cluey-components';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { Voucher } from '../../../../../api/types/voucher';
import HubPageLayout from '../../../../../common/hub/HubPageLayout';
import { CheckIcon } from '../../../../../icons';
import type { EnrolmentDetail, TutorTimeSlot } from '../../../../../types/hubInterfaces';
import { DATE_FORMAT_TYPE_8, SESSION_TIME_FORMAT } from '../../../../../util/constants';
import { PATH_HUB_UPCOMING_SESSIONS } from '../../../../../util/pagePath';

interface HistoryState {
  enrolmentDetails: EnrolmentDetail;
  tutorName: string;
  timeSlot: TutorTimeSlot;
  timezone: string;
  vouchers: Voucher[];
}

const SuccessWithVoucher = () => {
  const history = useHistory<HistoryState>();
  const {
    location: { state },
  } = history;
  const { tutorName, enrolmentDetails, timezone, timeSlot } = state;

  return (
    <HubPageLayout noContainer={false}>
      <div className="mt-10">
        <div className="m-auto flex h-[60px] w-[60px] items-center justify-center rounded-full bg-green-4">
          <CheckIcon className="text-white" width={40} height={40} />
        </div>
        <h1 className="my-5 text-center font-display text-[32px] font-bold sm:text-[40px]">Session added</h1>
        <div className="flex flex-col items-center gap-4 text-center text-lg">
          <p>{`A make-up session with ${tutorName} has been added to ${enrolmentDetails.studentName}'s Year ${enrolmentDetails.yearAsInteger} ${enrolmentDetails.enrolmentSubject} schedule:`}</p>
          <div className="text-center font-bold">
            <div>{moment.utc(timeSlot?.start).tz(timezone).format(DATE_FORMAT_TYPE_8)}</div>
            <div>
              {`
              ${moment.utc(timeSlot?.start).tz(timezone).format(SESSION_TIME_FORMAT)}
                - 
              ${moment.utc(timeSlot?.end).tz(timezone).format(SESSION_TIME_FORMAT)} 
            `}
            </div>
          </div>
          <p>
            You will see it reflected on your enrolment and session details soon. You will also receive an email
            confirming the details.
          </p>
          <p>A Cluey Voucher was used to book this session.</p>
        </div>
        <div className="m-auto mt-8 flex items-center justify-center">
          <LinkButton size="lg" appearance="reverse" to={PATH_HUB_UPCOMING_SESSIONS}>
            View upcoming sessions
          </LinkButton>
        </div>
      </div>
    </HubPageLayout>
  );
};

export default SuccessWithVoucher;
